import useAppTranslation from "@hooks/language/useAppTranslation";
import { ActionIcon, Button } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import { Link } from "react-router";

interface ISeeMoreProps {
  href: string;
  text?: string;
  inNewTab?: boolean;
  title?: string;
}

const SeeMore: React.FC<ISeeMoreProps> = ({ href, inNewTab, title }) => {
  const { t } = useAppTranslation("common.buttons");
  const options = { target: "_blank", rel: "noopener noreferrer" };

  return (
    <>
      <Button
        className="default-icon font-inter font-medium text-sm"
        component={Link}
        title={title || t("seeAll")}
        to={href}
        visibleFrom="sm"
        {...(inNewTab ? options : [])}
      >
        {t("seeAll")}
      </Button>
      <ActionIcon
        className="default-icon rounded-lg"
        component={Link}
        hiddenFrom="sm"
        title={title}
        to={href}
        {...(inNewTab ? options : [])}
      >
        <IconPlus />
      </ActionIcon>
    </>
  );
};

export default SeeMore;
